import React, { useRef, useState } from 'react';
import film2 from '../film2.jpg';
import strengthImg from '../film1.jpg';
import sinceAugustImg from '../film3.jpg';
import videoFile from '../v1.mp4';
import Footer from './Footer';

const Films = () => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [isPaused, setIsPaused] = useState(false);
  const videoRef = useRef(null);

  const similarProjects = [
    {
      image: strengthImg,
      title: 'Strength in Silence',
      desc: `Genre: Thriller&nbsp;|&nbsp;Status: In Development`,
    },
    {
      image: sinceAugustImg,
      title: 'Since August',
      desc: `Genre: Drama&nbsp;|&nbsp;Status: Released`,
    },
  ];

  const handlePlayPause = () => {
    if (!isPlaying) {
      setIsPlaying(true);
      videoRef.current?.play();
    } else {
      if (videoRef.current.paused) {
        videoRef.current.play();
        setIsPaused(false);
      } else {
        videoRef.current.pause();
        setIsPaused(true);
      }
    }
  };

  return (
    <div className="min-h-screen w-full bg-[#421B03] font-serif flex flex-col justify-start items-center px-0 sm:px-0">
      {/* HERO SECTION */}
      <div className="max-w-[1260px] flex flex-col pt-24 sm:pt-32 lg:pt-56 px-5 sm:px-6 xl:px-0 gap-y-10 md:gap-y-20">
        <h1 className="font-cinzel text-3xl sm:text-4xl md:text-[68px] xl:text-[90px] font-bold text-center text-white drop-shadow tracking-[-0.04em]">
          Metropolis - The Reboot
        </h1>
        <div className="w-full rounded-2xl overflow-hidden shadow-lg relative">
          <video
            ref={videoRef}
            src={videoFile}
            autoPlay
            muted
            loop
            playsInline
            className={`w-full h-full object-cover transition-opacity duration-500 ${
              isPlaying ? 'opacity-100 z-10' : 'opacity-0 z-0'
            }`}
            preload="metadata"
          >
            <source src="your-video.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          {!isPlaying && (
            <img
              src={film2}
              alt="Metropolis Title"
              className="absolute inset-0 w-full h-full object-cover z-0"
            />
          )}
          <button
            onClick={handlePlayPause}
            className="absolute inset-0 z-20 flex items-center justify-center text-6xl text-[#F2BA35] bg-black/40 hover:bg-black/60 transition"
          >
            <span className="drop-shadow">
              {!isPlaying || isPaused ? '▶' : '❚❚'}
            </span>
          </button>
        </div>
      </div>

      {/* LOG LINE, STATUS, GENRES, LANGUAGES */}
      <div className="w-full lg:max-w-[1050px] mx-auto px-5 sm:px-6 md:px-12 py-10 lg:py-20 flex flex-col gap-y-[40px]">
        <p className="text-white text-2xl lg:text-[30px] leading-[130%] font-ubuntu">
          <span className="font-medium text-[#F2BA35]">Logline: </span>
          In a sharply divided dystopia, the son of a powerful leader falls for
          a fearless woman from the working class who envisions a unifying
          champion. Their connection sparks a movement to dismantle class and
          gender oppression through a revolution grounded in empathy, identity,
          and the power of Deaf expression.
        </p>
        <div className="border-l border-solid border-[#F2BA35] py-2 pl-5">
          <p className="text-white text-2xl lg:text-[30px] leading-[130%] font-ubuntu font-medium">
            <span className="font-medium text-[#F2BA35]">Status: </span>
            In Development
          </p>
        </div>
        <div className="border-l border-solid border-[#F2BA35] py-2 pl-5">
          <p className="text-white text-2xl lg:text-[30px] leading-[130%] font-ubuntu font-medium">
            <span className="font-medium text-[#F2BA35]">Genre & Tags: </span>
            Narrative Feature | Sci-Fi | Drama | Romance | Thriller | Dystopian
            | Deafhood | Revolution | Social Justice | Intersectionality | ASL
          </p>
        </div>
        <div className="border-l border-solid border-[#F2BA35] py-2 pl-5">
          <p className="text-white text-2xl lg:text-[30px] leading-[130%] font-ubuntu font-medium">
            <span className="font-bold text-[#F2BA35]">
              Languages & Locations:{' '}
            </span>
            American Sign Language (ASL) | English · Atlanta, GA · Los Angeles,
            CA · New York, NY
          </p>
        </div>

        {/* SYNOPSIS SECTION */}
        <div className="mt-2">
          <h2 className="font-cinzel text-[36px] lg:text-[42px] xl:text-[50px] leading-[130%] font-regular text-white mb-4">
            Synopsis:
          </h2>
          <div className="space-y-6 font-regular text-white text-base md:text-lg">
            <p className="text-white text-2xl lg:text-[30px] leading-[130%] font-ubuntu">
              <em className="font-medium">Metropolis - The Reboot</em>{' '}
              reimagines the 1927 classic as a visionary story led by Deaf and
              marginalized voices. Set in a futuristic society where the
              privileged live above ground in opulence while the working class
              toils below, the city's peace is an illusion maintained by
              systemic control and silence.
            </p>
            <p className="text-white font-regular text-2xl lg:text-[30px] leading-[130%] font-ubuntu">
              When Freder, the idealistic son of the city's chief architect,
              meets Maria—a bold Deaf woman from the lower sectors—his world
              cracks open. Maria, a teacher and empathetic leader, foresees the
              arrival of a bridge between the classes: a new kind of hero who
              listens with their eyes and leads with heart. She challenges
              Freder to see beyond his inherited privilege and join her cause.
            </p>
            <p className="text-white font-regular text-2xl lg:text-[30px] leading-[130%] font-ubuntu">
              Together, they ignite a resistance movement that transcends spoken
              language and awakens a collective demand for change. Using ASL and
              visual communication, the revolutionaries defy surveillance and
              expose the emptiness of elitism. Maria becomes the face of a new
              era, proving that true leadership and connection come not from
              wealth or power, but from compassion, equity, and shared humanity.
            </p>
          </div>
        </div>
      </div>

      {/* SNAPS SECTION */}
      <div className=" max-w-[1260px] w-full mx-auto mt-12 px-5 sm:px-6 md:px-12">
        <h2 className="font-cinzel text-2xl lg:text-[12] xl:text-[60px] leading-[98%] font-bold text-center mb-6 text-white">
          Snaps from the project
        </h2>
        <div className="grid md:grid-cols-2	gap-6">
          <div className="w-full h-[300px] md:h-[540px] bg-[#D9D9D9] md:col-span-2	 rounded-[40px] flex items-center justify-center text-center text-2xl lg:text-[60px] leading-[98%] font-bold text-black relative overflow-hidden">
            METROPOLIS FILM IMAGES
          </div>
          <div className="w-full h-[300px] md:h-[540px] bg-[#D9D9D9] rounded-[40px] flex items-center justify-center text-center text-2xl lg:text-[60px] leading-[98%] font-bold text-black relative overflow-hidden">
            METROPOLIS FILM IMAGES
          </div>
          <div className="w-full h-[300px] md:h-[540px] bg-[#D9D9D9] rounded-[40px] flex items-center justify-center text-center text-2xl lg:text-[60px] leading-[98%] font-bold text-black relative overflow-hidden">
            METROPOLIS FILM IMAGES
          </div>
        </div>
      </div>

      {/* FOOTER SECTION */}
      <div className="mt-14 lg:mt-28 flex flex-col items-center max-w-[1030px]">
        <div className="flex gap-1 mb-3">
          {[...Array(5)].map((_, i) => (
            <span key={i} className="text-[#F2BA35] text-2xl">
              ★
            </span>
          ))}
        </div>
        <p className="text-white text-center text-3xl lg:text-[40px] leading-[132%] font-ubuntu mb-10">
          This retelling positions Deaf culture at the forefront of cinematic
          storytelling—celebrating ASL, challenging ableism, and breaking down
          social and gender hierarchies with unapologetic clarity and purpose.
        </p>
        <p className="italic text-[#F2BA35] text-sm lg:text-[30px] leading-[132%] text-center font-ubuntu font-medium">
          Created by: Mermaid Signature Production
          <br />
          Founder: Antoinette Abbamonte
        </p>
      </div>
      {/* more poject  */}
      <section className="w-full bg-[#2C4728] mt-16 py-14 lg:py-20 px-5 sm:px-6 md:px-12">
        <div className="max-w-[1260px] mx-auto">
          <h2 className="font-cinzel text-2xl md:text-[32px] lg:text-[40px] leading-[98%] font-extrabold text-white tracking-wide mb-12">
            View Similar Projects
          </h2>

          <div className="w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {/* card 1 */}
            {similarProjects.map((item, index) => {
              return (
                <div className="border border-[#4F6848] transition-all duration-400 ease-ease-custom  rounded-[30px] p-4 pb-12 bg-[#355031] hover:shadow-xl hover:backdrop-blur-[10px] hover:[background:linear-gradient(142deg,_rgba(255,255,255,0.21)_34.6847%,_rgba(255,255,255,0)_57.165%),_#355031]">
                  <div className="rounded-[20px] w-full md:h-[260px] relative overflow-hidden mb-6">
                    <img
                      src={item.image}
                      alt={item.title}
                      className="w-full object-cover w-full h-full"
                    />
                  </div>

                  <h3 className="text-xl md:text-[26px] lg:text-[30px] leading-[98%] font-ubuntu font-bold text-white mb-1">
                    {item.title}
                  </h3>
                  <p
                    className="italic text-gray-300 text-sm md:text-[18px] lg:text-[20px] leading-[132%] tracking-[-0.04em] mt-2 mb-0 font-ubuntu font-regular"
                    dangerouslySetInnerHTML={{ __html: item.desc }}
                  ></p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* CTA SECTION */}
      {/* <div className="max-w-3xl mx-auto mt-10 sm:mt-20 bg-gradient-to-r from-yellow-700 via-yellow-500 to-yellow-400 p-1 rounded-3xl">
        <div className="bg-[#3B1F0C] rounded-3xl p-4 sm:p-8 text-center">
          <img
            src={logoImg}
            alt="Logo"
            className="w-14 h-14 sm:w-20 sm:h-20 mx-auto mb-2 sm:mb-4"
          />
          <p className="text-yellow-400 font-medium uppercase text-xs md:text-sm tracking-wider mb-2">
            Support the movement
          </p>
          <h2 className="text-2xl md:text-3xl font-bold leading-snug mb-4">
            Changing the landscape of cinema through bold, authentic Deaf
            representation.
          </h2>
          <p className="text-gray-200 mb-6">
            Your contribution empowers the creation of Deaf-led films, nurtures
            emerging Deaf talent, and brings bold, authentic stories to screens
            around the world.
          </p>
          <button className="bg-gradient-to-r from-yellow-400 to-yellow-500 px-8 py-3 rounded-full text-white font-semibold shadow-md hover:scale-105 transition">
            Join us in transforming Hollywood →
          </button>
        </div>
      </div> */}

      {/* CONTACT SECTION */}
      {/* <div id="contact" className="max-w-4xl mx-auto mt-12 text-center">
        <h3 className="text-xl font-semibold mb-4 tracking-wide">Contact Us</h3>
        <div className="flex justify-center mb-6">
          <span className="bg-[#5c3924] px-8 py-2 rounded-full text-xs md:text-sm tracking-wide">
            info@mermaidsignatureproduction.com
          </span>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-6 text-sm">
          {['Twitter', 'Facebook', 'YouTube', 'Instagram'].map(
            (platform, index) => (
              <div
                key={index}
                className="bg-[#5c3924] py-3 rounded-full flex items-center justify-between px-5 cursor-pointer hover:bg-[#7a533a] transition"
              >
                <span className="tracking-wide">{platform.toUpperCase()}</span>
                <span className="text-lg font-bold">→</span>
              </div>
            )
          )}
        </div>
      </div> */}
    </div>
  );
};

export default Films;
